module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"contract":"Contract"},"fr":{"contract":"Contrat"}}')
  delete Component.options._Ctor
}
